import { brandNoteTypeZod } from "@nlc/shared-types";
import { z } from "zod";

export const BrandKnowledgeNoteSchema = z.object({
  description: z.string().min(1, "Description is required"),
  name: z.string().min(1, "Name is required"),
  noteType: brandNoteTypeZod,
});

export type BrandKnowledgeNoteFormValues = z.infer<
  typeof BrandKnowledgeNoteSchema
>;
